module.exports = require('../../../../../node_modules/@pkuanvil/nodebb-theme-pr/public/modules/taskbar.js');